export default __webpack_public_path__ + "static/media/push26.ae1a719f.gif";